/**Настройки выводимого сообщения */
export default class TirPmNotificationModel {
  /**Заголовок сообщения */
  title?: string = "";
  /**Подзаголовок сообщения */
  subtitle?: string = "";
  /**Заголовок детального содержания сообщения */
  labelButton?: string = "";
  /**Возможно ли закрытие сообщения */
  closable?: boolean = true;
  /**Время, через которое сообщение исчезнет */
  life?: number = 3000;
  /**Группа в которой отобразится сообщение */
  group?: string = "default";
  /**Группа в которой отобразится сообщение */
  type?: "error" | "info" | "success" | "warn";
  /**Группа в которой отобразится сообщение */
  colorIcon?: string;
  /**Коллбек для кнопки */
  callbackButton: () => void;
  constructor(obj?: Partial<TirPmNotificationModel>) {
    if (obj) Object.assign(this, obj);
  }
}
